module.exports = __webpack_public_path__ + "media/images/proof_links/hbo-f80e0a87187e538c1bd1204f5b439365.svg";